import { render } from "./Lighvideo.vue?vue&type=template&id=368b8fb3&scoped=true&ts=true"
import script from "./Lighvideo.vue?vue&type=script&lang=ts"
export * from "./Lighvideo.vue?vue&type=script&lang=ts"

import "./Lighvideo.vue?vue&type=style&index=0&id=368b8fb3&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368b8fb3"]])

export default __exports__